import PropTypes from 'prop-types';

import FormRow from './FormRow';
import RadioInput from './RadioInput';

export default function RadioGroup({
  description,
  onChange,
  required,
  options,
  value,
  name,
}) {
  return (
    <FormRow modifier="group" description={description} required={required}>
      {options.map(({ label, id, value: optionValue }) => (
        <RadioInput
          checked={optionValue === value}
          value={optionValue}
          onChange={onChange}
          required={required}
          label={label}
          name={name}
          key={id}
          id={id}
        />
      ))}
    </FormRow>
  );
}

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  required: PropTypes.bool,
};
